import type { LookoRouteObject } from '../LookoRouteObject';

export const 원스톱_솔루션_라우터 = {
  index: {
    path: '/one-stop-solution',
    handle: {
      title: '원스톱 솔루션',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  입고신청: {
    path: '/one-stop-solution/inbound',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/입고_신청_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '입고 신청',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  패키지_리스트: {
    path: '/one-stop-solution/package-list',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/원스톱_솔루션_업로드_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품화 결과 확인 / 업로드',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  주문출고_반품대행_신청: {
    path: '/one-stop-solution/order-return',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/주문_출고_반품_대행_신청_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '주문 출고 및 반품 대행',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  월별정산: {
    path: '/my-page/settlement/one-stop-solution',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/원스톱_솔루션_월별_정산_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원스톱 솔루션 월별 정산',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  반출관리: {
    path: '/one-stop-solution/product-carrying-out',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/상품_반출_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 반출 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  폐기관리: {
    path: '/one-stop-solution/product-disposal',
    async lazy() {
      const { default: Page } = await import('@/router/one-stop-solution/상품_폐기_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 폐기 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

export const 원스톱_솔루션_라우터_루트 = Object.values(원스톱_솔루션_라우터);
